import { useMutation } from "@tanstack/react-query";
import { axios } from "./axios";
import { useAuth } from "../context/AuthContext";
import { env } from "../utils/env";

interface Params {
  id: number;
  status: "true_match" | "false_positive" | "unknown";
  comment: string;
}

export const useUpdateScreeningMatchStatus = () => {
  const { authHeader } = useAuth();

  return useMutation((params: Params) =>
    axios.patch(
      `${env.verifyServiceUrl}individual/screening_match/${params.id}/status/`,
      { status: params.status, comment: params.comment },
      { headers: { Authorization: authHeader } },
    ),
  );
};
